import { render } from "./Shapes.vue?vue&type=template&id=2b373434&scoped=true&ts=true"
import script from "./Shapes.vue?vue&type=script&lang=ts"
export * from "./Shapes.vue?vue&type=script&lang=ts"

import "./Shapes.vue?vue&type=style&index=0&id=2b373434&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b373434"]])

export default __exports__